var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcon2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5787 3.00708C13.2642 3.00708 13.826 3.57575 13.826 4.26973C13.826 4.9637 13.2642 5.53238 12.5787 5.53238C11.8931 5.53238 11.3313 4.9637 11.3313 4.26973C11.3313 3.57575 11.8931 3.00708 12.5787 3.00708Z",
    fill: "url(#paint0_linear_406_924)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.02691 3.00708C9.71249 3.00708 10.2743 3.57575 10.2743 4.26973C10.2743 4.9637 9.71249 5.53238 9.02691 5.53238C8.34133 5.53238 7.77954 4.9637 7.77954 4.26973C7.77954 3.57575 8.34133 3.00708 9.02691 3.00708Z",
    fill: "url(#paint1_linear_406_924)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.38 3.00708C6.06558 3.00708 6.62737 3.57575 6.62737 4.26973C6.62737 4.9637 6.06558 5.53238 5.38 5.53238C4.69442 5.53238 4.13257 4.9637 4.13257 4.26973C4.13257 3.57575 4.69442 3.00708 5.38 3.00708Z",
    fill: "url(#paint2_linear_406_924)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M44.1627 0H3.83731C1.72344 0 0 1.74458 0 3.88434V44.1157C0 46.2554 1.72344 48 3.83731 48H44.1627C46.2766 48 48 46.2554 48 44.1157V3.88434C48 1.74458 46.2766 0 44.1627 0ZM20.4435 4.85784H46.8479V7.28675H20.4435V4.85784ZM46.7526 3.69155H20.4531V1.26265H44.2579C45.5053 1.26265 46.6574 2.33252 46.7526 3.69155ZM3.83731 1.26265H19.1962V7.28675H1.24737V3.88434C1.24737 2.42892 2.39949 1.26265 3.83731 1.26265ZM44.1627 46.7374H3.83731C2.39949 46.7374 1.15217 45.5711 1.15217 44.0193V8.5494H46.7526V44.1157C46.8479 45.5711 45.6005 46.7374 44.1627 46.7374Z",
    fill: "url(#paint3_linear_406_924)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M42.6202 12.1445H5.37042C5.08476 12.1445 4.79907 12.4337 4.79907 12.7228V42.4578C4.79907 42.7469 5.08476 43.0457 5.37042 43.0457H42.6202C42.9058 43.0457 43.1915 42.7566 43.1915 42.4578V12.7228C43.1915 12.4337 42.9058 12.1445 42.6202 12.1445ZM42.0488 41.8795H6.04644V13.4072H42.0488V41.8795Z",
    fill: "url(#paint4_linear_406_924)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M11.8072 36.4433H18.2345C19.7676 36.4433 21.0149 35.1806 21.0149 33.6288V26.1493C21.0149 25.8601 20.7292 25.5613 20.4436 25.5613H19.8723V23.7204C19.8723 21.0023 17.7584 18.8625 15.0733 18.8625C12.3881 18.8625 10.2742 21.0023 10.2742 23.7204V25.5613H9.70288C9.41722 25.5613 9.12206 25.8505 9.12206 26.1493V33.6288C9.02684 35.1806 10.2742 36.4433 11.8072 36.4433ZM14.978 32.1637C14.3115 32.1637 13.7306 31.5758 13.7306 30.9011C13.7306 30.2264 14.3115 29.6384 14.978 29.6384C15.6445 29.6384 16.2254 30.2264 16.2254 30.9011C16.2254 31.5758 15.6541 32.1637 14.978 32.1637ZM11.4263 23.7107C11.4263 21.6674 13.0546 20.0192 15.0733 20.0192C17.0919 20.0192 18.7201 21.6674 18.7201 23.7107V25.5517H17.4727V24.289C17.4727 23.9999 17.1871 23.7107 16.9015 23.7107C16.6158 23.7107 16.3302 23.9999 16.3302 24.289V25.5517H13.9306V24.289C13.9306 23.9999 13.645 23.7107 13.3498 23.7107C13.0546 23.7107 12.7784 23.9999 12.7784 24.289V25.5517H11.5311V23.7107H11.4359H11.4263ZM10.179 26.7276H19.7771V33.6288C19.7771 34.5059 19.101 35.277 18.1488 35.277H15.5588V33.33C16.6158 33.0408 17.3776 32.0674 17.3776 30.9975C17.3776 29.6385 16.3206 28.5686 14.978 28.5686C13.6354 28.5686 12.5785 29.6385 12.5785 30.9975C12.5785 32.1638 13.3498 33.0408 14.4067 33.33V35.277H11.8167C10.9502 35.277 10.1885 34.6023 10.1885 33.6288V26.7276H10.179Z",
    fill: "url(#paint5_linear_406_924)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M24.5762 35.277H38.402C38.6877 35.277 38.9829 34.9878 38.9829 34.6987V30.4191C38.9829 30.13 38.6972 29.8408 38.402 29.8408H24.5762C24.2905 29.8408 24.0049 30.13 24.0049 30.4191V34.6987C24.0049 34.9878 24.2905 35.277 24.5762 35.277ZM37.8211 34.0143H28.7944V31.0071H37.8211V34.0143ZM25.2523 30.9975H27.6517V34.0047H25.2523V30.9975Z",
    fill: "url(#paint6_linear_406_924)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M24.5762 27.9904H38.402C38.6877 27.9904 38.9829 27.7012 38.9829 27.412V23.1325C38.9829 22.8434 38.6972 22.5542 38.402 22.5542H24.5762C24.2905 22.5542 24.0049 22.8434 24.0049 23.1325V27.412C24.0049 27.7012 24.2905 27.9904 24.5762 27.9904ZM37.8211 26.7277H28.7944V23.7205H37.8211V26.7277ZM25.2523 23.7108H27.6517V26.7181H25.2523V23.7108Z",
    fill: "url(#paint7_linear_406_924)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_406_924",
    x1: 12.5787,
    y1: 3.00708,
    x2: 12.5787,
    y2: 5.53238,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8F5CCD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5B73CB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_406_924",
    x1: 9.02691,
    y1: 3.00708,
    x2: 9.02691,
    y2: 5.53238,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8F5CCD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5B73CB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_406_924",
    x1: 5.37997,
    y1: 3.00708,
    x2: 5.37997,
    y2: 5.53238,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8F5CCD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5B73CB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_406_924",
    x1: 24,
    y1: 0,
    x2: 24,
    y2: 48,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8F5CCD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5B73CB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_406_924",
    x1: 23.9953,
    y1: 12.1445,
    x2: 23.9953,
    y2: 43.0457,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8F5CCD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5B73CB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_406_924",
    x1: 15.0659,
    y1: 18.8625,
    x2: 15.0659,
    y2: 36.4433,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8F5CCD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5B73CB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_406_924",
    x1: 31.4939,
    y1: 29.8408,
    x2: 31.4939,
    y2: 35.277,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8F5CCD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5B73CB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_406_924",
    x1: 31.4939,
    y1: 22.5542,
    x2: 31.4939,
    y2: 27.9904,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8F5CCD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5B73CB"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon2);
export default __webpack_public_path__ + "static/media/icon2.2deae276b426c13ae13f9fb63c7a332a.svg";
export { ForwardRef as ReactComponent };